var TAaccordion = (function($) {
    'use strict';

    function init() {
        initAccordion();
    }

    function initAccordion() {
        $('.accordion__header').on('click', function() {
            const $header = $(this);
            const $content = $header.next('.accordion__content');
            const $item = $header.parent('.accordion__item');
            
            // Close other items
            $('.accordion__header').not($header).removeClass('active');
            $('.accordion__content').not($content).removeClass('active');
            
            // Toggle current item
            $header.toggleClass('active');
            $content.toggleClass('active');
        });
    }

        // Initialize dynamic block preview (editor).
        if( window.acf ) {
            window.acf.addAction( 'render_block_preview/type=accordion', init );
        }

    // Initialize on document ready
    // $(document).ready(function() {
    //     initAccordion();
    // });

    return {
        init:init
    };

}(jQuery));
